import { currencyLists } from './constants';

export const getCurrencySymbol = currencyCode => {
  if (!currencyCode) {
    const myr = currencyLists.find(c => c.cc === 'MYR');
    return myr ? myr.symbol : 'RM';
  }

  const match = currencyLists.find(c => c.cc === String(currencyCode).toUpperCase());

  if (match) {
    return match.symbol;
  }

  return String(currencyCode).toUpperCase();
};

export const formatAmountOff = (amountOff, currencyCode) => {
  if (amountOff == null) {
    return '—';
  }

  return `${getCurrencySymbol(currencyCode)} ${Number(amountOff).toFixed(2)} off`;
};

export const formatMoneyAmount = (amount, currencyCode) => {
  if (amount == null || amount === '') {
    return '—';
  }

  return `${getCurrencySymbol(currencyCode)} ${Number(amount).toFixed(2)}`;
};
